// TODO: after add redux, this file must remove!

const data = {
	photographer: 'م . ع',
	clientName: 'سعید خزائی',
	phone: '09380255332',
};

export default data;
